import type { ReactNode } from "react";

interface LearnLayoutProps {
    header: ReactNode;
    children: ReactNode;
}

// Frame of the learning screens: custom header, no site footer
const LearnLayout = ({ header, children }: LearnLayoutProps) => {
    return (
        <div className="min-h-screen flex flex-col">
            {header}
            <main className="flex-1 mb-20">{children}</main>
        </div>
    );
};

export default LearnLayout;